import { Component, Input, OnInit, inject } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { FloorplanDisplayMode, LocalizeFloorplanDisplayModePipe } from "@domain/project/floorplan/floorplan-state";
import { FormDirective } from "@odx/angular/components/form-field";
import { ToggleButtonComponent, ToggleButtonGroupComponent } from "@odx/angular/components/toggle-button-group";

@Component({
  selector: "app-floorplan-toggle-display-mode",
  imports: [
    ToggleButtonComponent,
    ToggleButtonGroupComponent,
    ReactiveFormsModule,
    FormDirective,
    LocalizeFloorplanDisplayModePipe,
  ],
  templateUrl: "./floorplan-toggle-display-mode.component.html",
})
export class FloorplanToggleDisplayModeComponent implements OnInit {
  private formBuilder = inject(FormBuilder);

  @Input({ required: true }) set activeFloorplan(floorplan: Floorplan) {
    this.floorplan = floorplan;
    this.displayModeForm?.controls["displayMode"].setValue(floorplan.floorplanState.displayMode, { emitEvent: false });
  }

  displayModeForm!: FormGroup;
  floorplan!: Floorplan;

  ngOnInit() {
    this.displayModeForm = this.formBuilder.group({
      displayMode: [this.floorplan.floorplanState.displayMode],
    });

    this.displayModeForm.valueChanges.subscribe((value) => {
      if (!this.displayModeForm.valid || this.displayModeForm.pristine) return;
      this.update(value.displayMode);
    });
  }

  private update(value: FloorplanDisplayMode) {
    this.floorplan.floorplanState.displayMode = value;
  }

  protected readonly FloorplanDisplayMode = FloorplanDisplayMode;
}
